var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCircleRemoveIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "circle-xmark",
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    "data-name": "Path 37",
    d: "M172.4,170.878l2.021-2.021a1.031,1.031,0,1,0-1.458-1.458l-2.019,2.061-2.058-2.024a1.031,1.031,0,0,0-1.458,1.458l2.021,2.021-1.985,2.021a1.031,1.031,0,1,0,1.458,1.458l2.022-2.021,2.021,2.021a1.031,1.031,0,1,0,1.458-1.458Z",
    transform: "translate(-159.946 -159.917)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    "data-name": "Path 38",
    d: "M11,0A11,11,0,1,0,22,11,11,11,0,0,0,11,0Zm3.442,13.02a1.031,1.031,0,0,1-1.458,1.458L11,12.457,8.979,14.477a1.031,1.031,0,0,1-1.458-1.458L9.542,11,7.52,8.942A1.031,1.031,0,0,1,8.978,7.483L11,9.543l2.021-2.021a1.031,1.031,0,1,1,1.458,1.458L12.458,11Z",
    opacity: 0.4
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleRemoveIcon);
export default __webpack_public_path__ + "static/media/circleRemove-icon.c28bec06bb56bd95548f73f5b1d5b2a6.svg";
export { ForwardRef as ReactComponent };